module.exports = __webpack_public_path__ + "static/media/alfredo-ayala.7806ab3f.jpg";